export enum BathroomType {
    UNKNOWN = 0,
    COMBINED = 1,
    PARTED = 2
}
